module.exports = __webpack_public_path__ + "img/chips5000.364dc3d5.png";